// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7112 ? "d46556e6" : chunkId) + "." + {"500":"8fc99257cd44b56c","7112":"f521be8c131dbb65","7664":"d5d1376a93bc5753","9910":"2f57e7fa84fff87f"}[chunkId] + ".js";
};